<script>
  import Checkbox from "../../Common/Checkbox.svelte";
  import {M} from "../../external";

  export let number = "",
    carrier = "",
    trackingUrl = "";
  let notify = false;

  export function getFulfillmentDetails() {
    return {
      number: number,
      carrier: carrier,
      trackingUrl: trackingUrl,
      notify: notify
    };
  }
</script>

<div class="popup-widget-wrapper">
  <div class="popup-input-wrapper f-left">
    <div class="info">
      <h5>{M.TRACKING_NUMBER}</h5>
      <input type="text" bind:value={number} />
    </div>
  </div>
  <div class="popup-input-wrapper f-left">
    <div class="info">
      <h5>{M.SHIPPING_CARRIER}</h5>
      <input type="text" bind:value={carrier} />
    </div>
  </div>
  <div class="popup-input-wrapper f-left">
    <div class="info">
      <h5>{M.TRACKING_URL}</h5>
      <input type="text" bind:value={trackingUrl} />
    </div>
  </div>

  <Checkbox bind:data={notify} label={M.SENDING_SHIPPING_DETAILS} clz="f20" />
</div>
